<template>
  <svg
    class="animate-spin fill-current"
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    fill="none"
  >
    <path
      d="M20 36a1.5 1.5 0 0 1 0-3c7.18 0 13-5.82 13-13S27.18 7 20 7 7 12.82 7 20c0 1.557.273 3.074.8 4.502a1.5 1.5 0 1 1-2.814 1.039A15.97 15.97 0 0 1 4 20c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16Z"
    />
  </svg>
</template>
